// extracted by mini-css-extract-plugin
module.exports = {"feedback":"FeedBackForm_feedback__3xzSK"};